/**
 * 省市级联选择器
 * 未输入时保留逐级点选路径，输入后按省/市名称做包含匹配（大小写、全半角不敏感）
 * @author ritaxxu
 */
import React from 'react'
import { Cascader } from 'antd'
import { CascaderProps, DefaultOptionType } from 'antd/lib/cascader'

import { areaTree } from '@configs/area'
import { matchAreaKeyword } from './utils'

export type AreaCascaderValue = string[]

// 仅支持单选，故排除 multiple
type Props = Omit<CascaderProps<DefaultOptionType>, 'options' | 'value' | 'onChange' | 'multiple'> & {
  value?: AreaCascaderValue;
  onChange?: (value: AreaCascaderValue) => void;
}

/**
 * 搜索配置：省名或市名命中即展示该选项（命中省份时其下全部城市都会展示）
 * limit 设为 false，避免城市较多的省份被默认条数截断
 */
const showSearch: CascaderProps<DefaultOptionType>['showSearch'] = {
  filter: (input, path) => path.some(option => matchAreaKeyword(String(option.label ?? ''), input)),
  limit: false,
}

export const AreaCascader: React.FC<Props> = (props) => {
  const { value, onChange, ...restProps } = props

  return (
    <Cascader
      allowClear
      placeholder="请选择省市"
      {...restProps}
      options={areaTree as unknown as DefaultOptionType[]}
      showSearch={showSearch}
      value={value}
      onChange={val => onChange?.(val as AreaCascaderValue)}
    />
  )
}

export default AreaCascader
